import apiClient from './client';

interface RunCreateRequest {
  name: string;
  config: {
    mode: 'training';
    training_config: Record<string, any>;
    robot_id: string;
  };
}

export const createRun = async (payload: RunCreateRequest) => {
  const { data } = await apiClient.post('/api/v1/runs', payload);
  return data;
};

export const fetchRuns = async () => {
  const { data } = await apiClient.get('/api/v1/runs');
  return data;
};

export const fetchRun = async (slug: string) => {
  const { data } = await apiClient.get(`/api/v1/runs/${slug}`);
  return data;
};

export const fetchRunMetrics = async (slug: string) => {
  const { data } = await apiClient.get(`/api/v1/runs/${slug}/metrics`);
  return data;
};

export const fetchRunTasks = async (slug: string) => {
  const { data } = await apiClient.get(`/api/v1/runs/${slug}/tasks`);
  return data;
};

export const fetchRunArtifacts = async (slug: string) => {
  const { data } = await apiClient.get(`/api/v1/runs/${slug}/artifacts`);
  return data;
};

export const fetchArtifactUrl = async (slug: string, s3Key: string) => {
  const { data } = await apiClient.get(`/api/v1/runs/${slug}/artifacts/url`, {
    params: { s3_key: s3Key },
  });
  return data.url;
};

export const cancelRun = async (slug: string) => {
  const { data } = await apiClient.post(`/api/v1/runs/${slug}/cancel`);
  return data;
};

export const pauseRun = async (slug: string) => {
  const { data } = await apiClient.post(`/api/v1/runs/${slug}/pause`);
  return data;
};

export const resumeRun = async (slug: string) => {
  const { data } = await apiClient.post(`/api/v1/runs/${slug}/resume`);
  return data;
};

export const deleteRun = async (slug: string) => {
  await apiClient.delete(`/api/v1/runs/${slug}`);
};

export const triggerEval = async (
  slug: string,
  iteration: number,
  taskId?: number,
) => {
  const { data } = await apiClient.post(`/api/v1/runs/${slug}/eval`, {
    iteration,
    task_id: taskId,
  });
  return data;
};
